function getBaseViews() {
  return null;
}
export { getBaseViews };
//# sourceMappingURL=getBaseViews.mjs.map
